@if (searchVisible || (isSearchOpened$ | async)) {
<div
    animate.enter="search-enter" animate.leave="search-leave"
    [class.search-box-default-open-on-desktop]="isSearchOpened$ | async"
    class="search-box-open"
>
    <div class="search">
        @if (isSearchOpened$ | async) {
        <mat-icon class="search-icon-defaultOpen">{{ searchIcon }}</mat-icon>
        }
        <input
            #searchInput
            [class.search-input-default-open-on-desktop]="!(isSearchOpened$ | async)"
            autofocus
            class="search-input"
            [placeholder]="placeholder"
            (keyup)="onSearchValueChange()"
        />
    </div>
    @if ((!(isMobile$ | async) && !defaultOpenOnDesktop) || (isMobile$ | async)) {
    <button mat-icon-button class="icon" (click)="closeSearch()">
        <mat-icon>{{ backIcon }}</mat-icon>
    </button>
    }
</div>
} @else {
<div animate.enter="search-enter" animate.leave="search-leave" class="search-box-closed">
    <button mat-icon-button class="icon" (click)="openSearch()">
        <mat-icon>{{ searchIcon }}</mat-icon>
    </button>
</div>
}
